import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatGrid = createCustomElementWrapper('kat-grid', 'KatGrid', {
    'colsL': 'cols-l',
    'colsM': 'cols-m',
    'colsS': 'cols-s',
    'colsXl': 'cols-xl',
    'colsXxl': 'cols-xxl',
    'verticalList': 'vertical-list',
}, {});
